"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OcppIdTokenAuthorizationStatus = void 0;
var OcppIdTokenAuthorizationStatus;
(function (OcppIdTokenAuthorizationStatus) {
    OcppIdTokenAuthorizationStatus[OcppIdTokenAuthorizationStatus["Accepted"] = 1] = "Accepted";
    OcppIdTokenAuthorizationStatus[OcppIdTokenAuthorizationStatus["Blocked"] = 2] = "Blocked";
    OcppIdTokenAuthorizationStatus[OcppIdTokenAuthorizationStatus["Expired"] = 3] = "Expired";
    OcppIdTokenAuthorizationStatus[OcppIdTokenAuthorizationStatus["Invalid"] = 4] = "Invalid";
    OcppIdTokenAuthorizationStatus[OcppIdTokenAuthorizationStatus["NoCredit"] = 5] = "NoCredit";
    OcppIdTokenAuthorizationStatus[OcppIdTokenAuthorizationStatus["NotFound"] = 6] = "NotFound";
})(OcppIdTokenAuthorizationStatus = exports.OcppIdTokenAuthorizationStatus || (exports.OcppIdTokenAuthorizationStatus = {}));
